import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserQueryKeys } from '@enums/react-query-keys';
import UserService from '@services/user-service';

const useDeleteProfilePicture = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => UserService.deleteProfilePicture(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UserQueryKeys.USER] }),
  });
};

export default useDeleteProfilePicture;
